import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "./navbar";
import { Contact } from "./contact";
import { ShoppingCart, Heart } from "lucide-react";
import { toggleFavoris } from "./slice";
import "../styles/listeClimatisseurs.css";

export function ListeClimatisseurs({ isHome }) {
    const listC = useSelector(s => s.listC);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const cherche = useSelector(s => s.cherche);
    const favoris = useSelector(s => s.favoris) || [];
    const list = listC.filter(a => a.nomClimatisseur.toLowerCase().includes(cherche.toLowerCase()));

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    let limit = list.length;
    if (isHome) {
        if (width >= 5120) limit = 14;
        else if (width >= 3400) limit = 12;
        else if (width >= 2000) limit = 12;
        else if (width >= 1536) limit = 10;
        else if (width >= 1110) limit = 8;
        else if (width >= 1000) limit = 6;
        else if (width >= 600) limit = 4;
        else limit = 4;
    }

    const displayedList = list.slice(0, limit);


    return (
        <>
            {!isHome && <Navbar />}

            <div className={`climatiseurs-list-container ${!isHome ? 'full-page-list' : ''}`}>
                <div className="section-title-bar" style={!isHome ? { backgroundColor: '#000033' } : {}}>
                    Les climatiseurs
                </div>

                <div className="climatiseurs-grid">
                    {displayedList.map(a => (
                        <div key={a.id} className="climatiseur-card">
                            <div className="card-image-wrapper">
                                <img src={a.image} alt={a.nomClimatisseur} />
                            </div>
                            <div className="card-info">
                                <h3 className="climatiseur-name">{a.nomClimatisseur}</h3>
                                <p className="climatiseur-price">{a.tailles[0].prix} DH</p>
                                <div className="card-actions-wrapper">
                                    <Link to={`/listeClimatisseurs/${a.id}`} className="btn-add-cart">
                                        <ShoppingCart className="icon-cart" /> Ajouter au panier
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {list.length === 0 && cherche && (
                    <div style={{ textAlign: 'center', marginBottom: '60px', marginTop: '-50px' }}>
                        <p>Aucun climatisseur trouvé pour "{cherche}"</p>
                    </div>
                )}

                {isHome && (
                    <div className="view-all-container">
                        <button className="btn-view-all" onClick={() => navigate('/listeClimatisseurs')}>
                            Voir tous les climatiseurs
                        </button>
                    </div>
                )}
            </div>
            {!isHome && <Contact />}
        </>
    );
};
